/**
 * What each subscription package includes — shown on Pricing (web + mobile).
 */

export const PLATFORM_SUBSCRIBER_FEATURES = [
  'Student enrolment, profiles, classes, and academic records',
  'Staff management, salaries, and GPS staff attendance',
  'School fees, canteen, expenses, and payment receipting',
  'Financial dashboards, reports, and fee balance tracking',
  'Accounting tools (trial balance, income statement, balance sheet)',
  'Announcements, circulars, and parent communication',
  'Student attendance marking and attendance reports',
  'Timetables, lesson notes, and academic performance views',
  'Admin web dashboard and mobile app for school operations',
  'Paystack payments for platform subscription and school fees',
  'Online admissions portal (parents apply and pay online)',
];

export const GOLD_PACKAGE = {
  name: 'Gold',
  tagline: 'Pay as you grow with your student roll',
  bestFor: 'Schools that want subscription cost to scale with enrollment',
  includes: [
    'Everything in the platform feature list above',
    'Billing based on your active student count',
    'Pay monthly or per term via Paystack',
    'Bulk SMS through your own mNotify SMS account',
    'No prepaid SMS wallet required',
  ],
};

export const SILVER_PACKAGE = {
  name: 'Silver',
  tagline: 'Flat software fee — predictable cost at any size',
  bestFor: 'Schools that want a fixed subscription and pay-as-you-go SMS',
  includes: [
    'Everything in the platform feature list above',
    'Flat subscription — same fee regardless of student count',
    'Monthly, termly, or yearly billing (discounts on termly & yearly)',
    'Bulk parent SMS with prepaid units purchased in-app',
    'SMS units bought separately when you need to message parents',
  ],
};
